/**
 * @generated SignedSource<<62689ae6de7d048d837f7984323cc4dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreProductOrderFooter_memberPackage$data = {
  readonly id: string;
  readonly package: {
    readonly displayInApp: {
      readonly termsAndConditionsUrl: string | null | undefined;
    } | null | undefined;
  };
  readonly squareCard: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "StoreProductOrderFooter_memberPackage";
};
export type StoreProductOrderFooter_memberPackage$key = {
  readonly " $data"?: StoreProductOrderFooter_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreProductOrderFooter_memberPackage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreProductOrderFooter_memberPackage",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFile",
      "kind": "LinkedField",
      "name": "squareCard",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DisplayInApp",
          "kind": "LinkedField",
          "name": "displayInApp",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "termsAndConditionsUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};
})();

(node as any).hash = "15974f15ec3f4ae3287772289870a88d";

export default node;
